/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_See_CapabilitiesInputs */

const en_landing_hero_see_capabilities = /** @type {(inputs: Landing_Hero_See_CapabilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See capabilities`)
};

/**
* | output |
* | --- |
* | "See capabilities" |
*
* @param {Landing_Hero_See_CapabilitiesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_hero_see_capabilities = /** @type {((inputs?: Landing_Hero_See_CapabilitiesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_See_CapabilitiesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_hero_see_capabilities(inputs)
});